import { Injectable } from '@angular/core';
import { TabToTabChannelName } from '../../enums/tab-to-tab-channel-name.enum';
import { createGUID } from '../../helpers/guid-helpers';
import { Dictionary } from '../../models/dictionary.model';
import { TabToTabChannelModel } from '../../models/tab-to-tab-channel.model';

@Injectable()
export class TabToTabService {
    private channels: Dictionary = new Dictionary([]);

    private connectChannelNoGuid(channelName: TabToTabChannelName): TabToTabChannelModel {
        const channel = new TabToTabChannelModel(channelName, '');
        this.channels.add(channel.key, channel);
        return channel;
    }

    /**
     * Connects to the channel with the given name.
     * @param channelName The channel name.
     * @returns The channel.
     */
    connectChannel(channelName: TabToTabChannelName): TabToTabChannelModel {
        const guid = createGUID();
        const channel = new TabToTabChannelModel(channelName, guid);
        this.channels.add(channel.key, channel);
        return channel;
    }

    /**
     * Disconnects the channel with the given name.
     * Call when destroying pages listening for messages to prevent memory leaks.
     * @param channel The channel to disconnect
     */
    disconnectChannel(channel: TabToTabChannelModel): void {
        if (!channel || !channel.key || !this.channels.containsKey(channel.key)) {
            return;
        }

        this.channels[channel.key].messageSubject$.complete();
        this.channels[channel.key].broadcastChannel.close();
        this.channels.remove(channel.key);
    }

    /**
     * Sends a message over the given channel.
     * @param channelName The channel name.
     * @param message The message to send.
     */
    sendMessage(channelName: TabToTabChannelName, message: any): void {
        if (!this.channels.containsKey(channelName)) {
            this.connectChannelNoGuid(channelName);
        }

        this.channels[channelName].broadcastChannel.postMessage(message);
    }
}
